module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"or":"nebo","all":"Všechny","search_by_certification":"Hledejte podle certifikace","search_by_field":"Hledejte podle oboru certifikace"},"en":{"or":"or","all":"All","search_by_certification":"Search by certification","search_by_field":"Search by field"},"it":{"or":"o","all":"Tutte","search_by_certification":"Ricerca per certificazioni","search_by_field":"Cerca per campo"}}')
  delete Component.options._Ctor
}
